<template>
  <div class="w-full h-full py-4 lg:py-6 rounded-md">
    <div
      class="w-full flex 2xl:gap-5 justify-between lg:justify-end py-2 gap-2 lg:gap-4"
    >
      <div class="flex items-center">
        <form @submit.prevent="searchMap" class="flex gap-2 lg:gap-4 w-full">
          <input
            type="text"
            name="map_search"
            id="map_search"
            v-model="map_search"
            placeholder="Search by name"
            class="rounded-lg w-[70%] lg:w-[240px]"
          />
          <button type="submit" class="btn text-sm px-4 py-2 rounded-lg">
            Search
          </button>
        </form>
      </div>
      <button
        @click="add_camapaign_recipient_map = true"
        class="btn text-sm px-4 py-2 rounded-lg"
      >
        Map+
      </button>
    </div>

    <div v-if="loader == false" class="w-full overflow-x-scroll">
      <div v-if="campaign_std_list.length > 0">
        <table class="min-w-full bg-primary2 shadow-md">
          <thead class="bg-primary border-b text-start sticky top-0 text">
            <tr class="text-left whitespace-nowrap">
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                S.No
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Campaign
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Student
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Sent
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Opened
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Clicked
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Sent at
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Opened at
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Clicked at
              </th>
              <!-- <th scope="col" class="text-start text-base font-medium px-6 py-4">
            Action
          </th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-if="campaign_std_list.length <= 0">
              <td></td>
              <td class="px-4 py-2 text-left">{{ message }}</td>
            </tr>
            <tr
              v-else
              class="text-left border-b whitespace-nowrap"
              v-for="(recipient, index) in campaign_std_list"
              :key="index"
            >
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                {{ (currentPage - 1) * perPage + index + 1 }}
              </td>

              <td class="px-4 py-2 xl:px-6 xl:py-4">
                <p>{{ recipient.campaign.name }}</p>
              </td>
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                {{ recipient.recipient.email }}
              </td>
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                <img
                  v-if="recipient.sent"
                  :src="accept"
                  alt="sent"
                  class="w-4 h-4 object-contain"
                />
                <img
                  v-else
                  :src="cross"
                  alt="not sent"
                  class="w-4 h-4 object-contain"
                />
              </td>
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                <img
                  v-if="recipient.opened"
                  :src="accept"
                  alt="sent"
                  class="w-4 h-4 object-contain"
                />
                <img
                  v-else
                  :src="cross"
                  alt="not sent"
                  class="w-4 h-4 object-contain"
                />
              </td>
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                <img
                  v-if="recipient.clicked"
                  :src="accept"
                  alt="sent"
                  class="w-4 h-4 object-contain"
                />
                <img
                  v-else
                  :src="cross"
                  alt="not sent"
                  class="w-4 h-4 object-contain"
                />
              </td>
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                <p v-if="recipient.sent_at">
                  {{ formatDate(recipient.sent_at) }}
                </p>
              </td>
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                <p v-if="recipient.opened_at">
                  {{ formatDate(recipient.opened_at) }}
                </p>
              </td>
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                <p v-if="recipient.clicked_at">
                  {{ formatDate(recipient.clicked_at) }}
                </p>
              </td>
              <!-- <td class="whitespace-nowrap px-4 py-2 relative">
            <div class="inline-flex items-center justify-center">
              <button
                @click="toggleEdit(recipient.id)"
                class="size-8 rounded-full mt-1 p-0 hover:bg-slate-300/20 focus:bg-slate-300/20 active:bg-slate-300/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="size-4.5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                  />
                </svg>
              </button>
              <div
                class="absolute -left-[110px] top-4 w-[130px] z-50"
                v-show="popupId === recipient.id"
              >
                <div
                  class="popper-box rounded-md border border-slate-150 bg-white py-0 font-inter dark:border-navy-500 dark:bg-navy-700"
                >
                  <ul>
                    <li
                      @click="
                        editCampaignRecipientList(recipient.id);
                        editCampaginStatus = true;
                      "
                    >
                      <p
                        class="flex h-6 items-center px-3 pr-4 cursor-pointer font-medium tracking-wide outline-none transition-all hover:bg-[#2563eb] hover:text-white focus:bg-slate-100 focus:text-slate-800 text-xs"
                      >
                        Edit
                      </p>
                    </li>
                     <li @click="deleteCampaign(campaigns.id, campaigns.name)">
                      <p
                        class="flex h-6 items-center px-3 pr-4 cursor-pointer font-medium tracking-wide outline-none transition-all hover:bg-[#2563eb] hover:text-white focus:bg-slate-100 focus:text-slate-800 text-xs"
                      >
                        Delete
                      </p>
                    </li> 
                  </ul>
                </div>
              </div>
            </div>
          </td> -->
            </tr>
          </tbody>
          <tfoot class="bg-primary border-b text">
            <tr class="">
              <td colspan="9" class="px-4 py-2 xl:px-6 xl:py-4">
                <div class="flex justify-between items-center w-full">
                  <h2 class="">
                    Showing {{ first_value }} to
                    {{ total_std_list.count }}
                  </h2>
                  <h2 class="">
                    Page {{ total_std_list.current_page_number }} of
                    {{ total_std_list.total_pages }}
                  </h2>
                  <div class="">
                    <button
                      v-if="map_prev"
                      @click="prevMapList"
                      class="btn px-2 py-1 rounded-md"
                    >
                      prev
                    </button>
                    <button
                      v-if="map_next"
                      @click="nextMapList"
                      class="btn px-2 py-1 rounded-md"
                    >
                      next
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div v-else class="" style="height: calc(100vh - 80px)">
        <div class="flex flex-col justify-center items-center h-full">
          <img
            :src="no_data"
            class="w-full h-[500px] object-contain"
            alt=""
            srcset=""
          />
          <h1 class="text-black text-lg">NO DATA FOUND</h1>
        </div>
      </div>
    </div>

    <!-- map campaign student list  -->
    <div
      v-if="add_camapaign_recipient_map == true"
      class="flex items-center justify-center w-full h-full fixed top-0 left-0 z-50 bg-black bg-opacity-60"
    >
      <div
        class="bg-white p-6 gap-y-5 flex flex-col justify-center items-center w-full lg:w-[500px] rounded-xl relative !z-999"
      >
        <div class="flex justify-between w-full">
          <h2 class="text-xl font-semibold">Map Campaign & Recipient</h2>
          <span
            @click="add_camapaign_recipient_map = false"
            class="font-semibold text-lg hover:text-red-700 cursor-pointer"
            >x</span
          >
        </div>
        <form
          action=""
          @submit.prevent="campaignRecipientCreate"
          class="flex flex-col gap-2 lg:gap-3 justify-start w-full"
        >
          <div class="flex flex-col text-start">
            <label for="fname"
              >Select Campaign <span class="text-red-500">*</span></label
            >
            <select
              name="campaign"
              id="campaign"
              required
              v-model="selected_campaign"
              class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
            >
              <option value="" selected disabled>Select Campaign</option>
              <option v-for="el in campaignList" :key="el.id" :value="el.id">
                {{ el.name }}
              </option>
            </select>
          </div>
          <div class="flex flex-col text-start">
            <label for="lname"
              >Select Student <span class="text-red-500">*</span></label
            >
            <select
              name="student"
              id="student"
              required
              v-model="selected_student"
              class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
            >
              <option value="" selected disabled>Select Student</option>
              <option
                v-for="std in recipientList"
                :key="std.id"
                :value="std.id"
              >
                {{ std.email }}
              </option>
            </select>
          </div>
          <div class="flex justify-center pt-3">
            <button type="submit" class="w-40 px-4 py-2 btn rounded-md">
              Submit
            </button>
          </div>
        </form>
        <div class="flex items-center justify-center pt-3">
          <div class="w-full border-t border-black h-0"></div>
          <div class="px-3 text-black">or</div>
          <div class="w-full border-t border-black h-0"></div>
        </div>
        <form
          @submit.prevent="campaignBulkUpload"
          class="flex flex-col gap-2 lg:gap-3 justify-start w-full"
        >
          <h1 class="text-lg">Bulk Upload</h1>
          <div class="flex flex-col text-start">
            <label for="updatedName">Select Campaign</label>
            <select
              name="campaign"
              id="campaign"
              required
              v-model="selected_campaign"
              class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
            >
              <option value="" selected disabled>Select Campaign</option>
              <option v-for="el in campaignList" :key="el.id" :value="el.id">
                {{ el.name }}
              </option>
            </select>
          </div>
          <div class="flex justify-between items-center">
            <div class="flex flex-col text-start w-full">
              <label for="updatedName">Upload the excel file</label>
              <input
                type="file"
                name=""
                @change="handleFileUpload"
                id="student_upload"
                accept=".xlsx"
                required
              />
            </div>
            <div class="w-[20%] flex justify-center items-center">
              <a
                :href="file_download"
                download
                class="w-full flex justify-center tooltip"
              >
                <img
                  :src="download_file"
                  alt="download file"
                  class="w-5 h-5 object-contain"
                />
                <span class="tooltiptext text-xs w-full"> Sample File</span>
              </a>
            </div>
          </div>

          <div class="flex justify-center pt-3">
            <button type="submit" class="w-40 px-4 py-2 btn rounded-md">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
    <!-- edit recipient List   -->
    <div
      v-if="editCampaignStudentListStatus == true"
      class="z-50 flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-80"
    >
      <div
        class="bg-white p-6 gap-y-5 flex flex-col justify-center items-center w-full lg:w-[500px] rounded-xl relative !z-999"
      >
        <div class="p-8 w-full text-lg h-full">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-semibold text-black">
              Update Campaign-student
            </h2>
            <span
              @click="editCampaignStudentListStatus = false"
              class="font-semibold text-lg hover:text-red-700 cursor-pointer"
              >x</span
            >
          </div>
          <form
            action=""
            @submit.prevent="updateRecipientList"
            class="flex flex-col gap-2 lg:gap-3 justify-start w-full"
          >
            <div class="flex flex-col text-start">
              <label for="update_fname">Select Campaign</label>
              <input
                v-model="update_fname"
                id="update_fname"
                type="text"
                class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              />
            </div>
            <div class="flex flex-col text-start">
              <label for="update_lname">Select Student</label>
              <input
                v-model="update_lname"
                id="update_lname"
                type="text"
                class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              />
            </div>
            <div class="flex flex-col text-start">
              <label for="update_email">Email</label>
              <input
                v-model="update_email"
                id="update_email"
                type="text"
                class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              />
            </div>
            <!-- <div class="flex flex-col text-start">
              <label for="updatedName">Campaign List</label>
              <select
                class="border focus:outline-none rounded-md px-3 py-2 w-full bg-white"
                name="recipientList"
                id="recipientList"
                v-model="updateRecipientLists.campaign"
              >
                <option value="" disabled selected>Update Campaign</option>
                <option
                  v-for="recipients in campaignList"
                  :key="recipients.id"
                  :value="recipients.id"
                >
                  {{ recipients.name }}
                </option>
              </select>
            </div>
            <div class="flex flex-col text-start">
              <label for="updatedEmail">Recipient</label>
              <select
                class="border focus:outline-none rounded-md px-3 py-2 w-full bg-white"
                name="recipientList"
                id="recipientList"
                v-model="updateRecipientLists.recipient"
              >
                <option value="" disabled selected>Update Recipient</option>
                <option
                  v-for="recipients in individualList"
                  :key="recipients.id"
                  :value="recipients.id"
                >
                  {{ recipients.email }}
                </option>
              </select>
            </div> -->

            <div class="flex justify-center pt-3">
              <button
                type="submit"
                class="py-2 w-40 rounded-lg bg-gradient-to-r from-blue-500 to-[#2563EB] text-white hover:bg-gradient-to-l hover:from-blue-500 hover:to-[#2563EB]"
              >
                Submit
              </button>
            </div>
          </form>
          <!-- <div v-if="updateValue" class="py-3">
            <p class="text-lg font-semibold">{{ updateValue }}</p>
          </div> -->
        </div>
      </div>
    </div>
    <div v-if="loader" class="flex flex-col justify-center items-center">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      Loading...
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "CampaignMapping",
  data() {
    return {
      loader: false,
      add_camapaign_recipient_map: false,
      editCampaignStudentListStatus: false,
      campaign_std_list: [],
      update_campaign_std: [],
      campaignList: [],
      recipientList: [],
      popupId: "",
      selected_campaign: "",
      selected_student: "",
      update_fname: "",
      update_lname: "",
      update_email: "",
      message: "",
      campaign_student_id: "",
      file: null,
      currentPage: 1,
      perPage: 20,
      accept: require(`${process.env.VUE_APP_ACCEPT}`),
      cross: require(`${process.env.VUE_APP_CROSS}`),
      next: require(`${process.env.VUE_APP_NEXT}`),
      back: require(`${process.env.VUE_APP_BACK}`),
      no_data: require(`${process.env.VUE_APP_NODATA}`),
      download_file: require(`${process.env.VUE_APP_DOWNLOAD_FILE}`),
      file_download: `${process.env.VUE_APP_FILE_DOWNLOAD}`,
      map_search: "",
      total_std_list: "",
      map_next: "",
      map_prev: "",
      current_page_number: "",
      total_pages: "",
      first_value: 1,
      last_value:20,
    };
  },
  async created() {
    this.loader = true;
    await this.getCampaignStudent();
    await this.getRecipient();
    await this.getCampaign();
  },
  computed: {
    ...mapGetters(["userInfo", "isAuthenticated"]),
  },
  methods: {
    async getCampaign() {
      axios
        .get(
          `${process.env.VUE_APP_API}/campaign/list/?Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.data.status == 200) {
            this.campaignList = resp.data.data.data;
            this.message = resp.data.data.message;
            setTimeout(() => {
              this.loader = false;
            }, 1000);
          } else if (resp.data.data.status == 400) {
            setTimeout(() => {
              this.loader = false;
            }, 1000);
          }
        })
        .catch((err) => {
          console.log("error ", err);
        });
    },
    async getRecipient() {
      axios
        .get(
          `${process.env.VUE_APP_API}/recipient/list/?Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.data.status == 200) {
            this.recipientList = resp.data.data.data;
            this.message = resp.data.data.message;
          }
        })
        .catch((err) => {
          console.log("error ", err);
        });
      // axios
      //   .get(
      //     `${process.env.VUE_APP_API}/enquire/list/?Key=${this.userInfo.data.token}`
      //   )
      //   .then((resp) => {
      //     if (resp.data.status == 200) {
      //       this.recipientList = resp.data.data;
      //       this.message = resp.data.message;
      //     }
      //   })
      //   .catch((err) => {
      //     console.log("error ", err);
      //   });
    },
    async getCampaignStudent() {
      axios
        .get(
          `${process.env.VUE_APP_API}/campaign-recipient/list/?Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.data.status == 200) {
            this.campaign_std_list = resp.data.data.data;
            this.message = resp.data.data.message;
            this.total_std_list = resp.data;
            this.map_next = resp.data.next;
            this.map_prev = resp.data.previous;
            this.current_page_number = resp.data.current_page_number;
            this.total_pages = resp.data.total_pages;
          }
        })
        .catch((err) => {
          console.log("error ", err);
        });
    },
    async nextMapList() {
      await axios
        .get(`${this.map_next}`)
        .then((resp) => {
          this.total_std_list = resp.data;
          this.campaign_std_list = resp.data.data;
          this.map_next = resp.data.next;
          this.map_prev = resp.data.previous;
          this.current_page_number = resp.data.current_page_number;
          this.first_value = (this.current_page_number - 1) * 20 + 1;
          this.last_value = this.current_page_number * 20;
          this.total_pages = resp.data.total_pages;
          this.loader = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // previous map list
    async prevMapList() {
      await axios
        .get(`${this.map_prev}`)
        .then((resp) => {
          this.total_std_list = resp.data;
          this.campaign_std_list = resp.data.data;
          this.map_next = resp.data.next;
          this.map_prev = resp.data.previous;
          this.current_page_number = resp.data.current_page_number;
          this.total_pages = resp.data.total_pages;
          this.first_value = (this.current_page_number - 1) * 20 + 1;
          this.last_value = (this.last_value / 20 - 1) * 20;
          this.loader = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // search mapping
    searchMap() {
      axios
        .get(
          `${process.env.VUE_APP_API}/campaign-recipient/list/?search=${this.map_search}&Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.data.status == 200) {
            this.campaign_std_list = resp.data.data.data;
            this.message = resp.data.data.message;
          }
        })
        .catch((err) => {
          console.log("error ", err);
        });
    },
    editCampaignRecipientList(id) {
      this.campaign_student_id = id;
      this.editCampaignStudentListStatus = true;
      axios
        .get(
          `${process.env.VUE_APP_API}/campaign-recipient/list/?id=${id}&Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.data.status == 200) {
            this.update_campaign_std = resp.data.data.data;
            this.update_fname = this.update_campaign_std[0].first_name;
            this.update_lname = this.update_campaign_std[0].last_name;
            this.update_email = this.update_campaign_std[0].email;
            this.message = resp.data.data.message;
            this.popupId = "";
          }
        })
        .catch((err) => {
          console.log("error ", err);
        });
    },
    updateCampaignRecipientList() {
      const mapData = {
        campaign: this.selected_campaign,
        recipient: this.selected_student,
      };
      axios
        .put(
          `${process.env.VUE_APP_API}/campaign-recipient/update-destroy/${this.campaign_student_id}/?key=${this.userInfo.data.token}`,
          mapData
        )
        .then((resp) => {
          if (resp.status == 200) {
            this.editCampaignStudentListStatus = false;
            this.getCampaignStudent();
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    campaignRecipientCreate() {
      const mapData = {
        campaign: this.selected_campaign,
        recipient: this.selected_student,
      };
      axios
        .post(
          `${process.env.VUE_APP_API}/campaign-recipient/post/?Key=${this.userInfo.data.token}`,
          mapData
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.add_camapaign_recipient_map = false;
            this.getCampaignStudent();
            this.selected_campaign = "";
            this.selected_student = "";
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    campaignBulkUpload() {
      const formData = new FormData();
      formData.append("file", this.file, this.file.name);
      formData.append("campaign", this.selected_campaign);
      axios
        .post(
          `${process.env.VUE_APP_API}/bulk-upload/campaign-recipients/${this.selected_campaign}/?Key=${this.userInfo.data.token}`,
          formData
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.add_camapaign_recipient_map = false;
            this.getCampaignStudent();
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    toggleEdit(id) {
      if (this.popupId === id) {
        this.popupId = null;
      } else {
        this.popupId = id;
      }
    },
    // YYYY-MM-DDThh:mm
    formatUpdateDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    },
    formatDate(dateString) {
      if (!dateString) return "Invalid Date";
      const date = new Date(dateString);

      const dateOptions = { month: "short", day: "2-digit", year: "numeric" };
      const timeOptions = {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata",
      };

      const formattedDate = date.toLocaleDateString("en-IN", dateOptions);
      const formattedTime = date.toLocaleTimeString("en-IN", timeOptions);

      return `${formattedDate} / ${formattedTime}`;
    },
    // pagenation
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
};
</script>

<style></style>
